<template lang="pug">
   Modal(ref="dlg" title="Recall Order" closeable="true")
    .recall-order-modal.ssp-form-horizontal
      .form-group(v-if="errorMsg")
      .form-group
        label.ic-label Reason
        .ic-control
          input.form-control(v-model="reason")
    div(slot="footer")
      button.btn.btn-primary(@click="recallOrder") OK
      button.btn.btn-default(@click="$refs.dlg.cancel()") Cancel
</template>

<script>
import miniToastr from 'mini-toastr'
import Modal from '@/components/common/Modal'
import Core from '@/service/apis/Core'

export default {
  props: ['orderId'],
  data() {
    return {
      reason: null,
      errorMsg: null
    }
  },
  methods: {
    recallOrder() {
      Core.recallOrder(this.orderId)
        .then(() => {
          this.$refs.dlg.close()
          miniToastr.success('Successfully applied for recall')
          this.$emit('success')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    open() {
      this.$refs.dlg.open()
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.recall-order-modal {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/RecallOrderModal.vue